export default __webpack_public_path__ + "static/media/dog.85e78b12.jpeg";